module.exports = __webpack_public_path__ + "static/media/unionpay.aff58e55.png";